import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button } from '@node-space/ui-components'

interface RewardsWithdrawActionsProps {
  onCancel: () => void
  isPending: boolean
  selectedCurrency: string
}

export const RewardsWithdrawActions = ({
  onCancel,
  isPending,
  selectedCurrency,
}: RewardsWithdrawActionsProps) => {
  const { t } = useTranslation()

  return (
    <Box flex justify="between" gapX={12} paddingT={24}>
      <Button onClick={onCancel} variant="secondary" type="button" testId="cancel-button">
        {t('cancel')}
      </Button>
      <Button
        variant="primary"
        type="submit"
        testId="withdraw-button"
        disabled={isPending}
        loading={isPending}
      >
        {t('rewards.withdrawCurrency', {
          currency: selectedCurrency,
        })}
      </Button>
    </Box>
  )
}
